import React, { useState } from "react";
import CareQualityFooter from "./CareQualityFooter";
import ReviewCard from "./ReviewCard";
import reviews from "./reviewsData";

const ViewTestimonialsDrawer = ({ show, onClose }) => {
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 500);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  if (!show && !isClosing) return null;

  return (
    <div
      className="d-flex d-md-none justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100 bg-black bg-opacity-50 password-popup"
      onClick={handleBackdropClick}
    >
      <div
        className={`bg-white rounded py-4 px-2 pb-0 pt-3 shadow-lg password-box ${
          isClosing ? "slide-down" : "slide-up"
        }`}
      >
        <div className="d-flex justify-content-center w-100">
          <div
            className="hr-close bg-black rounded-1 mb-5"
            onClick={handleClose}
          />
        </div>
        <div className="d-flex flex-row align-items-center justify-content-between mx-4 mt-0 mb-5 ">
          <h5 className="text-primary-600 mb-0 fw-bold">Testimonials</h5>
        </div>
        <div className="d-flex flex-column justify-content-between">
          <div className="modal-body mx-4">
            {reviews.map((review, index) => (
              <div key={index}>
                <ReviewCard isViewTestimonial={true} review={review} avatarSrc={review.profile}/>
                {index < reviews.length - 1 && (
                  <hr className="border gray-border my-4" />
                )}
              </div>
            ))}
            <div className="w-100 mt-7 mb-4">
              <CareQualityFooter />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewTestimonialsDrawer;
